
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.287 14.723v.672c0 .535-.393.98-.904 1.055l-.166.61a.76.76 0 01-.733.564H4.842a.76.76 0 01-.734-.563l-.16-.61a1.07 1.07 0 01-.91-1.06v-.673c0-.36.29-.648.649-.648h3.952c.36.005.648.293.648.653zm3.043-9.058a5.638 5.638 0 01-1.59 3.933 5.196 5.196 0 00-1.391 2.82.937.937 0 01-.928.79H3.905a.928.928 0 01-.923-.785 5.253 5.253 0 00-1.401-2.83 5.642 5.642 0 01-1.58-3.866A5.65 5.65 0 015.626 0a5.661 5.661 0 015.703 5.665zM6.304 2.234a.64.64 0 00-.639-.639 4.093 4.093 0 00-4.089 4.089.64.64 0 001.278 0 2.815 2.815 0 012.811-2.811.636.636 0 00.64-.64z","fill":"#D1D1D1"}})])
          )
        }
      }
    